import { toast as baseToast } from 'react-toastify'
import { getTranslation } from './utils'

/** API messages that are translation keys rather than text: "branch-group-added", "address_added". */
const MESSAGE_KEY = /^[a-z0-9]+([-_][a-z0-9]+)+$/

/** Pages a server message key is looked up in, first match wins. */
const MESSAGE_PAGES = ['server-messages', 'general']

const humanize = (key) => {
    const text = key.replace(/[-_]+/g, ' ')
    return text.charAt(0).toUpperCase() + text.slice(1)
}

const translateKey = (key) => {
    const state = window.__REDUX_SHARED_STORE__?.getState?.()
    const translation = state?.translation?.translation
    const language = state?.translation?.language
    for (const page of MESSAGE_PAGES) {
        const entry = getTranslation(page, translation)?.[key]
        const text = entry?.[language] || entry?.english
        if (text) return text
    }
    return humanize(key)
}

/** The text to show for a toast: server message keys become readable text, anything else is kept. */
export const toastText = (content) =>
    typeof content === 'string' && MESSAGE_KEY.test(content.trim()) ? translateKey(content.trim()) : content

const wrap = (fn) => (content, ...rest) => fn(toastText(content), ...rest)

/** react-toastify's `toast`, but raw server message keys are shown as text. */
export const toast = Object.assign(wrap(baseToast), baseToast, {
    success: wrap(baseToast.success),
    error: wrap(baseToast.error),
    info: wrap(baseToast.info),
    warning: wrap(baseToast.warning),
    warn: wrap(baseToast.warn),
})

export default toast
